export const openURLbyTarget = (url: string, target?: string): void => {
  if (target === '_blank') {
    window.open(url);
  } else {
    window.location.assign(url);
  }
};
